module.exports = __webpack_public_path__ + "img/cnh-icon.14fb1556.png";